import React, { useRef, useCallback } from 'react'

import { DownloadApp } from '@enuygun/icons'
import { useTranslation } from 'next-i18next'

import { useAppState } from 'context/AppContext'
import { useDeviceType } from 'hooks/useDeviceType'
import { domainURL } from 'utils/domainURL'
import { getAnalyticsRequestId } from 'utils/analyticsRequestId'
import sendTrackerLog from 'utils/tracker'

import * as S from './ManageMyBookingWingie.styled'

const AppQr = () => {
  const { isMobile, isTablet } = useDeviceType()
  const { t } = useTranslation()
  const { market } = useAppState()
  const appQrCardRef = useRef<HTMLDivElement | HTMLAnchorElement>(null)

  const isWingie = market !== 'tr'

  //@ts-ignore
  const url = domainURL[market]
  const QR_IMAGE = 'https://cdn2.enuygun.com/media/lib/uploads/image/wingie-qr-49027.png'

  const qrHeading = t('ManageMyBooking.appQr.heading')
  const qrSubheading = t('ManageMyBooking.appQr.subheading')
  const mobileDownloadUrl = `${url}/r/29Jk47`

  // AppQr mobile click tracking
  const handleMobileClick = useCallback(() => {
    if (!isMobile && !isTablet) return

    const environment = 'MOBILE_WEB'
    const requestId = getAnalyticsRequestId()

    sendTrackerLog({
      category: isWingie ? 'wingie-homepage' : 'enuygun-homepage',
      page: isWingie ? 'wingie-homepage' : 'enuygun-homepage',
      type: 'click',
      message: 'manage_my_booking_app_qr_click',
      environment: environment,
      requestId,
      linkUrl: mobileDownloadUrl,
      qrHeading: qrHeading || null,
      qrSubheading: qrSubheading || null,
      isMobile: true,
      market: market,
    })
  }, [isMobile, isTablet, market, isWingie, mobileDownloadUrl, qrHeading, qrSubheading])

  return (
    <S.ManageMyBookingWingieCardElement
      ref={appQrCardRef}
      as={isMobile ? 'a' : 'div'}
      href={isMobile && mobileDownloadUrl}
      target="_blank"
      cursor={isMobile ? 'pointer' : 'default'}
      data-testid="wingie-homepage-manageMyBooking-appQr-card-container"
      onClick={isMobile || isTablet ? handleMobileClick : undefined}
    >
      <S.ManageMyBookingWingieCard
        key={t('ManageMyBooking.appQr.heading')}
        isMobile={isMobile}
        order={isMobile ? 'row' : 'row-reverse'}
        data-testid="wingie-homepage-manageMyBooking-appQr-card"
      >
        <S.Image>{isMobile ? <DownloadApp width={40} height={40} /> : <img loading="lazy" src={QR_IMAGE} width={60} height={60} alt={t('ManageMyBooking.appQr.alt')} />}</S.Image>
        <div>
          <S.ManageMyBookingWingieCardHeading data-testid="wingie-homepage-manageMyBooking-appQr-heading">{t('ManageMyBooking.appQr.heading')}</S.ManageMyBookingWingieCardHeading>
          <S.ManageMyBookingWingieCardSubheading data-testid="wingie-homepage-manageMyBooking-appQr-subheading">
            {t('ManageMyBooking.appQr.subheading')}
          </S.ManageMyBookingWingieCardSubheading>
        </div>
      </S.ManageMyBookingWingieCard>
    </S.ManageMyBookingWingieCardElement>
  )
}

export default AppQr
